"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Copy = Copy;
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _tooltip = require("devextreme-react/tooltip");
require("devextreme/dist/css/dx.common.css");
require("devextreme/dist/css/dx.light.css");
var _styles = require("@material-ui/styles");
var _clipboard = _interopRequireDefault(require("clipboard"));
var _copyToClipboard = require("@catalytic/catalytic-icons/lib/glyphs/copy-to-clipboard.svg");
var _TextInputContext = _interopRequireDefault(require("../TextInput/TextInputContext"));
var _Text = require("../../Text/Text");
var _ModalView = require("../../View/ModalView/ModalView");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type ThemeType } from '../../style/ThemeTypes';

// Styles mostly copied from PasswordInput
// We might move these styles to the theme or a dedicated layout component
// for rendering icons on the right of inputs*/
// Styles mostly copied from PasswordInput
// We might move these styles to the theme or a dedicated layout component
// for rendering icons on the right of inputs
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    button: {
      display: 'flex',
      backgroundColor: 'transparent',
      padding: "0 ".concat(theme.functions.toRem(theme.variables.inputPaddingRight)),
      color: theme.colors.battleshipGrey,
      cursor: 'pointer',
      '&:hover': {
        color: theme.colors.black
      },
      '&:disabled': theme.mixins.disabled
    },
    buttonContainer: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0
    },
    copyToClipboardGlyph: {
      height: '1.5rem',
      width: '1.5rem'
    },
    tooltip: {
      zIndex: function zIndex(_ref) {
        var modalViewContext = _ref.modalViewContext;
        return "".concat(modalViewContext ? theme.zIndex.modal : theme.zIndex.menu, " !important");
      }
    }
  };
});
function Copy() {
  var modalViewContext = React.useContext(_ModalView.ModalViewContext);
  var textInputContext = (0, _TextInputContext.default)();
  if (textInputContext === undefined) throw new Error("Copy must be used within a TextInputContext.Provider\n      Please notify component library team if this component needs to handle a new use case");
  var classes = useStyles({
    modalViewContext: modalViewContext
  });
  // Keeps track of tooltip visibility due to copy success
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    didCopy = _React$useState2[0],
    setDidCopy = _React$useState2[1];
  // Keeps track of tooltip visibility due to mouse events
  var _React$useState3 = React.useState(false),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    tooltipIsVisible = _React$useState4[0],
    setTooltipIsVisible = _React$useState4[1];
  // Keeps track of when to change the tooltip message. Note: it can not be based on the tooltip visibility
  // states above. The Tooltip component won't unmount the tooltip for about a second after we've passed
  // visibility false, so the message will flip back to the default for the last second before the
  // tooltip umounts.
  var _React$useState5 = React.useState(false),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isTooltipSuccessMessage = _React$useState6[0],
    setIsTooltipSuccessMessage = _React$useState6[1];
  React.useEffect(function () {
    if (didCopy) {
      if (isTooltipSuccessMessage !== true) setIsTooltipSuccessMessage(true);
      // The tooltip success message should linger for 3 seconds after a successful copy
      var timeout = setTimeout(function () {
        return setDidCopy(false);
      }, 1000 * 3);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [didCopy, isTooltipSuccessMessage]);
  var buttonRef = React.useRef(null);
  // Using a callback ref rather than useRef hook since we need to be notified when the ref has
  // been attached to the DOM node so we can configure ClipboardJS.
  // https://reactjs.org/docs/hooks-reference.html#useref
  var buttonRefCallback = React.useCallback(function (buttonNode) {
    if (buttonNode) {
      var clipboard = new _clipboard.default(buttonNode, {
        target: function target() {
          var _textInputContext$inp;
          // I don't understand why ref.current is not readable according to the built-in type def
          // https://github.com/facebook/flow/commit/aa19606d9fcab63185acf1e05270820690fea4d7#r35549743
          // $FlowIgnore
          return textInputContext === null || textInputContext === void 0 ? void 0 : (_textInputContext$inp = textInputContext.inputRef) === null || _textInputContext$inp === void 0 ? void 0 : _textInputContext$inp.current;
        }
      });
      clipboard.on('success', function () {
        setDidCopy(true);
      });
      // Make ref accessible outside this function so it can be passed as the target node for <Tooltip />
      buttonRef.current = buttonNode;
    }
  }, [textInputContext]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.button,
    onMouseEnter: function onMouseEnter() {
      return setTooltipIsVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setTooltipIsVisible(false);
    },
    ref: buttonRefCallback,
    type: "button"
  }, /*#__PURE__*/React.createElement(_copyToClipboard.ReactComponent, {
    className: classes.copyToClipboardGlyph
  }))), /*#__PURE__*/React.createElement(_tooltip.Tooltip, {
    className: classes.tooltip,
    target: buttonRef.current,
    visible: tooltipIsVisible || didCopy,
    closeOnOutsideClick: false
    // Don't change the tooltip message back to the default until it has hidden
    ,
    onHidden: function onHidden() {
      return setIsTooltipSuccessMessage(false);
    }
  }, /*#__PURE__*/React.createElement(_Text.ExtraSmallText, null, isTooltipSuccessMessage === true ? /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Copied!",
    id: "copy.success.tooltip"
  }) : /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Copy",
    id: "copy.default.tooltip"
  }))));
}
Copy.displayName = 'Copy';
var _default = exports.default = Copy;
//# sourceMappingURL=Copy.js.map